import { createSlice } from '@reduxjs/toolkit';

const subjectsSlice = createSlice({
  name: 'delta/subjects',
  initialState: null,
  reducers: {
    getSubjects: (state, action) => action.payload,
    resetSubjects: () => null,
  },
});

export const { getSubjects, resetSubjects } = subjectsSlice.actions;

export default subjectsSlice.reducer;
